import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { BarChart3Icon } from "lucide-react";

interface CompetitorData {
  name: string;
  protein: string;
  sugar: string;
  price: string;
}

interface MarketComparisonCardProps {
  competitors: CompetitorData[];
}

export default function MarketComparisonCard({
  competitors,
}: MarketComparisonCardProps) {
  return (
    <Card className="shadow-md h-full">
      <CardHeader className="bg-slate-100 pb-2">
        <CardTitle className="text-lg font-medium flex items-center gap-2">
          <BarChart3Icon size={18} className="text-blue-600" />
          Market Comparison
        </CardTitle>
      </CardHeader>
      <CardContent className="p-0">
        <table className="w-full">
          <thead>
            <tr className="bg-blue-50">
              <th className="px-4 py-2 text-left text-sm font-medium text-slate-700">
                Product
              </th>
              <th className="px-4 py-2 text-left text-sm font-medium text-slate-700">
                Protein
              </th>
              <th className="px-4 py-2 text-left text-sm font-medium text-slate-700">
                Sugar
              </th>
              <th className="px-4 py-2 text-left text-sm font-medium text-slate-700">
                Price
              </th>
            </tr>
          </thead>
          <tbody>
            <tr className="bg-amber-50">
              <td className="px-4 py-2 text-sm font-medium">
                Heinz UmamiLift™
              </td>
              <td className="px-4 py-2 text-sm text-green-700 font-medium">
                5g
              </td>
              <td className="px-4 py-2 text-sm text-green-700 font-medium">
                -15%
              </td>
              <td className="px-4 py-2 text-sm">$3.99</td>
            </tr>
            {competitors.map((competitor, index) => (
              <tr
                key={index}
                className={index % 2 === 0 ? "bg-white" : "bg-slate-50"}
              >
                <td className="px-4 py-2 text-sm">{competitor.name}</td>
                <td className="px-4 py-2 text-sm">{competitor.protein}</td>
                <td className="px-4 py-2 text-sm">{competitor.sugar}</td>
                <td className="px-4 py-2 text-sm">{competitor.price}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </CardContent>
    </Card>
  );
}
